<template>
  <div class="my-profil">
    <MyPageHeader
      v-if="isLoggedIn"
      v-model:activeTab="activeTab"
    />
    <main
      class="my-profil__content"
      :class="{ 'my-profil__content--no-header': !isLoggedIn }"
    >
      <template v-if="isLoggedIn">
        <UserInfo v-if="activeTab === 'profile'" />
        <MyBookings v-else />
      </template>
      <div
        v-else
        class="my-profil__unauthorized"
      >
        <LogIn routeToPage="UserInfo" />
      </div>
    </main>
  </div>
</template>

<script lang="ts">
  import { defineComponent, computed, ref, onMounted, watch } from 'vue'
  import { useUserStore } from '@/stores/userStore'
  import { useBookingStore } from '@/stores/bookingStore'
  import { useJourneyStore } from '@/stores/journeyStore'
  import { useRouter } from 'vue-router'
  import MyPageHeader from './MyPageHeader.vue'
  import MyBookings from './MyBookings.vue'
  import UserInfo from './UserInfo.vue'
  import LogIn from '@/components/MyPage/LogIn/LogIn.vue'

  export default defineComponent({
    name: 'MyProfil',
    components: {
      MyPageHeader,
      MyBookings,
      UserInfo,
      LogIn,
    },
    setup() {
      const userStore = useUserStore()
      const bookingStore = useBookingStore()
      const journeyStore = useJourneyStore()
      const router = useRouter()
      const isLoggedIn = computed(() => userStore.isLoggedIn)
      const activeTab = ref('profile')

      onMounted(() => {
        bookingStore.$reset()
        journeyStore.$reset()

        const currentRoute = router.currentRoute.value
        if (currentRoute.name === 'MyBookings') {
          activeTab.value = 'bookings'
        }
      })

      watch(activeTab, (newTab) => {
        const currentRoute = router.currentRoute.value.name
        if (newTab === 'bookings' && currentRoute !== 'MyBookings') {
          router.push({ name: 'MyBookings' })
        } else if (newTab === 'profile' && currentRoute !== 'UserInfo') {
          router.push({ name: 'UserInfo' })
        }
      })

      return {
        isLoggedIn,
        activeTab,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .my-profil {
    &__content {
      max-width: $main-width;
      margin: 0 auto;

      &--no-header {
        padding-top: 4rem;
      }
    }

    &__unauthorized {
      max-width: 500px;
      margin: 0 auto;
    }
  }
</style>
